<div class="modal-background" *ngIf="show">
    <div class="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="display: block;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Desea rechazar {{data.length}} imagen?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closed()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form [formGroup]="form">             
                <div class="form-group">
                  <label for="message-text" class="col-form-label">Mensaje:</label>
                  <textarea class="form-control" id="message-text" formControlName="mensaje"></textarea>
                </div>
              </form>
            </div>
            <div class="modal-footer" *ngIf="tipe==='multiselect'">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closed()">Close</button>
              <button type="button" class="btn btn-primary" (click)="sendTwo()">Enviar el mensaje a {{data.length}} imagenes </button>
            </div>
            <div class="modal-footer" *ngIf="tipe !=='multiselect'">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closed()">Close</button>
              <button type="button" class="btn btn-primary" (click)="send()">Enviar mensaje</button>
            </div>
          </div>
        </div>
      </div>
</div>
